const pendingTimeoutIds = new Set<number>();

export const clearAllPending = () => {
  for (const timeoutId of pendingTimeoutIds) {
    window.clearTimeout(timeoutId);
  }
  pendingTimeoutIds.clear();
};

export function debounce(callback: (...args: unknown[]) => void, wait: number) {
  let timeoutId: number | null = null;

  return (...args: unknown[]) => {
    window.clearTimeout(timeoutId ?? undefined);

    timeoutId = window.setTimeout(() => {
      callback.apply(null, args);
      if (timeoutId !== null) {
        pendingTimeoutIds.delete(timeoutId);
      }
    }, wait);

    pendingTimeoutIds.add(timeoutId);
  };
}
